import { createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';
import { Helper } from '../../../shared/utils/utils';
import { TournamentsWithPagination } from '../../../tournament/models/tournaments.interface';
import { HomeTournament } from '../../models/enums/home.enum';
import { HomeActions } from '../actions/actions-type.action';

export interface HomeState {
    tournaments: {
        pcTournaments: TournamentsWithPagination;
        mobileTournaments: TournamentsWithPagination;
        consoleTournaments: TournamentsWithPagination;
        isEndlessSeries: TournamentsWithPagination;
    };
    error: BadResponseWithError | null;
    isLoading: boolean;
}

const initialState: HomeState = {
    tournaments: {
        pcTournaments: {
            items: [],
            page: 0,
            totalPages: 0,
            isExhausted: false,
            isLoading: false,
            itemsCount: 0,
        },
        mobileTournaments: {
            items: [],
            page: 0,
            totalPages: 0,
            isExhausted: false,
            isLoading: false,
            itemsCount: 0,

        },
        consoleTournaments: {
            items: [],
            page: 0,
            totalPages: 0,
            isExhausted: false,
            isLoading: false,
            itemsCount: 0,

        },
        isEndlessSeries:{
            items: [],
            page: 0,
            totalPages: 0,
            isExhausted: false,
            isLoading: false,
            itemsCount: 0,

        }
    },
    error: null,
    isLoading: false,
};

export const homeReducer = createReducer(
    initialState,
    on(HomeActions.fetchHomeTournaments, (state, action) => {
        const updateIsLoading = (
            oldSate: TournamentsWithPagination
        ): TournamentsWithPagination => ({
            ...oldSate,
            isLoading: true,
        });

        const tournaments = updateHomeTournaments(
            action.payload.type,
            state,
            updateIsLoading
        );

        return {
            ...state,
            ...tournaments,
            isLoading: true,
        };
    }),
    on(HomeActions.fetchHomeTournamentsSuccess, (state, action) => {
        const { items, page, pageSize, total } = action.payload.response;
        const totalPages = Math.ceil(total / pageSize);
        const isExhausted = page === totalPages;
        const homeTournamentType = action.payload.type;
        const updateTournaments = (
            oldState: TournamentsWithPagination
        ): TournamentsWithPagination => ({
            items: action.payload.patchExistingValue
                ? items
                : [...(oldState?.items ?? []), ...items],
            page,
            totalPages,
            isExhausted,
            itemsCount: action.payload.response.itemsCount,
            isLoading: false,
        });

        const tournaments = updateHomeTournaments(
            homeTournamentType,
            state,
            updateTournaments
        );

        return {
            ...state,
            ...tournaments,
            isLoading: false,
        };
    }),
    on(HomeActions.fetchHomeTournamentsFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    }))
);

const updateHomeTournaments = (
    type: HomeTournament,
    state: HomeState,
    updateFn: (oldStore: TournamentsWithPagination) => TournamentsWithPagination
) => {
    const homeState = Helper.deepCopy<HomeState>(state);

    switch (type) {
        case HomeTournament.PC:
            homeState.tournaments.pcTournaments = updateFn(
                homeState.tournaments.pcTournaments
            );
            break;
        case HomeTournament.Mobile:
            homeState.tournaments.mobileTournaments = updateFn(
                homeState.tournaments.mobileTournaments
            );
            break;
        case HomeTournament.Console:
            homeState.tournaments.consoleTournaments = updateFn(
                homeState.tournaments.consoleTournaments
            );
            break;
            case HomeTournament.isEndlessSeries:
            homeState.tournaments.isEndlessSeries = updateFn(
                homeState.tournaments.isEndlessSeries
            );
            break;
    }

    return homeState;
};
